module.exports = __webpack_public_path__ + "img/Og-graph-p-800.7d6eedae.png";